export enum DailyOdometerActionTypes {
    SET_DAILYODOMETER = "SET_DAILYODOMETER",
    CLEAR_DAILYODOMETER = "CLEAR_DAILYODOMETER"
}